import KnowMore from './KnowMore';

export default KnowMore;
